import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from './firebaseConfig'; // Import your Firebase config
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { setPersistence, browserLocalPersistence, signInWithEmailAndPassword } from 'firebase/auth'; // Import persistence functions

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Set persistence to local
        setPersistence(auth, browserLocalPersistence) // Use the imported persistence
            .then(() => {
                const unsubscribe = auth.onAuthStateChanged(async (user) => {
                    console.log('Auth state changed:', user); // Log the user object
                    if (user) {
                        try {
                            const userDocRef = doc(db, 'users', user.uid);
                            const userDocSnap = await getDoc(userDocRef);
                            if (userDocSnap.exists()) {
                                setUser({ uid: user.uid, ...userDocSnap.data() });
                            } else {
                                console.log('No such user document!');
                            }
                        } catch (error) {
                            console.error('Error fetching user document:', error);
                        }
                    } else {
                        setUser(null);
                    }
                    setLoading(false);
                });

                return () => unsubscribe(); // Cleanup subscription on unmount
            })
            .catch((error) => {
                console.error('Error setting persistence:', error);
                setLoading(false); // Ensure loading is set to false in case of error
            });
    }, []);

    const updateUser = async (updatedData) => {
        if (user) {
            const userDocRef = doc(db, 'users', user.uid);
            await setDoc(userDocRef, updatedData, { merge: true }); // Update user data
            setUser((prev) => ({ ...prev, ...updatedData })); // Update local state
        }
    };

    const logout = async () => {
        await auth.signOut(); // Sign out from Firebase
        setUser(null); // Clear user state
    };

    const login = async (email, password) => {
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            return userCredential.user;
        } catch (error) {
            console.error('Error logging in:', error);
            throw new Error('Login failed. Please check your credentials.');
        }
    };

    return (
        <AuthContext.Provider value={{ user, loading, updateUser, logout, login }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);